import { privacyManagerOTTViews } from "../../constants";
export class OTTNavButtonSettings {
  constructor() {
    let overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const defaults = {
      text: 'Nav Button',
      iconUrl: '',
      width: {
        type: 'auto',
        value: 1
      },
      padding: {
        paddingLeft: 15,
        paddingRight: 15,
        paddingTop: 10,
        paddingBottom: 10
      },
      margin: {
        marginLeft: 10,
        marginRight: 10,
        marginTop: 10,
        marginBottom: 10
      },
      font: {
        fontSize: 14,
        fontWeight: '400',
        color: '#ffffff',
        fontFamily: 'arial, helvetica, sans-serif'
      },
      background: '#1890ff',
      border: {
        borderWidth: 0,
        borderColor: '#000000',
        borderTopLeftRadius: 5,
        borderTopRightRadius: 5,
        borderBottomLeftRadius: 5,
        borderBottomRightRadius: 5,
        borderStyle: 'solid'
      },
      underline: '#FFFFFF',
      lineSize: {
        type: 'auto',
        value: 1
      },
      lineOffset: {
        type: 'auto',
        value: 1
      },
      action_type: null,
      languages: {},
      selectedLanguage: '',
      startFocus: false,
      view: privacyManagerOTTViews.HOME,
      iconPadding: {
        paddingLeft: 0,
        paddingRight: 0,
        paddingTop: 0,
        paddingBottom: 0
      },
      iconMargin: {
        marginLeft: 0,
        marginRight: 0,
        marginTop: 0,
        marginBottom: 0
      },
      iconWidth: {
        type: 'px',
        value: 10
      }
    };
    Object.assign(this, defaults, overrides);
  }
}
export const OTTNavButtonTypes = {
  content: {
    text: {
      title: 'Text',
      type: 'TextLanguage'
    }
  },
  navigation: {
    view: {
      title: 'Select View',
      type: 'Navigation'
    }
  },
  content: {
    text: {
      title: 'Text',
      type: 'InputLanguage'
    },
    iconUrl: {
      title: 'Icon URL',
      type: 'Input'
    }
  },
  settings: {
    startFocus: {
      title: 'First Focused Item',
      type: 'Switch'
    },
    width: {
      title: 'Width',
      type: 'Size'
    },
    padding: {
      title: 'Padding',
      type: 'Padding'
    },
    margin: {
      title: 'Margin',
      type: 'Margin'
    }
  },
  styles: {
    font: {
      title: 'Font',
      type: 'Font'
    },
    background: {
      title: 'Background Color',
      type: 'ColorPicker'
    },
    border: {
      title: 'Border',
      type: 'Border'
    },
    underline: {
      title: 'Underline',
      type: 'ColorPicker'
    },
    lineSize: {
      title: 'Underline Size',
      type: 'Size'
    },
    lineOffset: {
      title: 'Offset Size',
      type: 'Size'
    },
    iconPadding: {
      title: 'Icon Padding',
      type: 'Padding'
    },
    iconMargin: {
      title: 'Icon Margin',
      type: 'Margin'
    },
    iconWidth: {
      title: 'Icon Width',
      type: 'Size'
    }
  }
};